export default {
  Hide: 0,
  Prepare: 1,
  Upgrade: 2,
  Maintain: 3
};